import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { apiCall } from '../../../../../crud/api.crud';
import { ActivityVolunteer } from '../../../../../interfaces/activity';
import { FaCircle } from 'react-icons/fa';

interface Props {
  activityId: number;
}

const Volunteers = ({ activityId }: Props) => {
  const { t } = useTranslation();
  const [data, setData] = useState<ActivityVolunteer[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!activityId) return;

    setLoading(true);
    setData([]);

    apiCall(`activity/${activityId}/volunteersAccepted`, null, 'GET')
      .then((response) => {
        setData(response.data.data);
      })
      .catch(() => {
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [activityId]);

  if (loading) {
    return (
      <div className="mt-3">
        <p>Buscando...</p>
      </div>
    );
  }

  if (!data.length) {
    return (
      <div className="mt-3">
        <p className="mt-5">{t('activities.activity_teamNull')}</p>
      </div>
    );
  }

  return (
    <div className="mt-3">
      <ul className="list-group list-group-flush">
        {data.map(({ id, name, surname }) =>
          id ? (
            <li key={`user-${id}`} className="list-group-item px-0 border-0 bg-transparent d-flex align-items-center">
              <FaCircle className="me-2 text-primary" style={{ fontSize: '0.4rem', margin: '2px', padding: '2px' }} />
              <Link to={`/profile/${id}`} className="text-decoration-none text-primary">
                {`${name} ${surname}`}
              </Link>
            </li>
          ) : null,
        )}
      </ul>
    </div>
  );
};

export default Volunteers;
